package diana.soleil.design.iraniancanadienbazzar.core.firebase

import diana.soleil.design.iraniancanadienbazzar.core.common.CrashReporter
import diana.soleil.design.iraniancanadienbazzar.core.common.NoOpCrashReporter

// Crashlytics has no web SDK (GitLive publishes no js artifact); web crash triage relies on
// Analytics + browser consoles until a web-specific reporter (e.g. Sentry) is ever warranted.
internal actual fun platformCrashReporter(): CrashReporter = NoOpCrashReporter
